<template>
  <div class="log-box df">
    <!-- <a-radio-group v-model:value="recordType" class="record-type">
      <a-radio-button value="randomSerial">随机生成机身号</a-radio-button>
      <a-radio-button value="randomRecord">机身号历史记录</a-radio-button>
      <a-radio-button value="serialDestroy">销毁机身号记录</a-radio-button>
    </a-radio-group> -->
    <render-serial class="render-serial" @renderSerialUpdate="renderSerialUpdate" @updateSearchTable="updateSearchTable"
      ref="renderSerialRef"></render-serial>
    <div class="log-table">
      <div class="log-toolbar">
        <div class="df both-side">
          <a-space>
            <a-select style="width: 130px" placeholder="设备类型" v-model:value="machieType" allowClear
              :dropdown-match-select-width="false" @change="handleUpdateMachineType" :options="machineTypeOption">
            </a-select>

            <a-select style="width: 120px" placeholder="设备型号" v-model:value="payload.searchType" allowClear
              :dropdown-match-select-width="false" @change="handleUpdateSearchType" :options="machineOptionByType">
            </a-select>
            <a-select style="width: 150px" placeholder="使用状态" v-model:value="payload.isUsed" allowClear
              @change="onSearch">
              <a-select-option :value="true">已使用</a-select-option>
              <a-select-option :value="false">未使用</a-select-option>
            </a-select>
            <a-input style="width: 150px" v-model:value="payload.serial" placeholder="设备名称" allowClear></a-input>
            <a-button @click="onSearch" type="primary">搜索</a-button>
          </a-space>

          <a-button type="danger" @click="openDeleteConfirmModal" :disabled="selectedRowKeys.length === 0">删除</a-button>
        </div>
      </div>
      <a-table :columns="columns" :dataSource="tableData" :pagination="false" rowKey="id" class="log-data"
        :scroll="{ y: 'calc(100vh - 340px)' }" :rowClassName="(record, index) => (index % 2 === 1 ? 'table-striped' : null)
          " :row-selection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }">
        <template #isUsed="{ record }">
          <a-tag v-if="record.isUsed" color="#35B7AD">已使用</a-tag>
          <a-tag v-else color="#ec975d">未使用</a-tag>
        </template>

        <template #action="{ record }">
          <a-button @click="updateStatus(record)" type="primary">修改状态</a-button>
        </template>
      </a-table>

      <a-modal v-model:visible="deleteModalVisiable" title="提示" @ok="handleDelete" @cancel="handelCancel">
        <a-input type="password" placeholder="请输入删除密码" v-model:value="deletePassword"></a-input>
      </a-modal>

      <div class="df both-side">
        <div></div>
        <a-pagination show-size-changer v-model:current="page.pageNum" v-model:pageSize="page.lineNum"
          @showSizeChange="showSizeChange" @change="currenChange" :total="page.total"
          :pageSizeOptions="['20', '50', '70', '100']" :show-total="(total) => `共 ${total} 条`" />
      </div>
    </div>
  </div>
</template>

<script>
import {
  defineComponent,
  reactive,
  ref,
  computed,
  createVNode,
  toRefs,
} from "vue";
import { Modal } from "ant-design-vue";
import { ExclamationCircleOutlined } from "@ant-design/icons-vue";
import {
  getSerialList,
  randomSerial,
  deleteserial,
  updateserial,
} from "@/request/view/serial";
import { notice, Toast } from "@/utils";
import { useForm } from "ant-design-vue/lib/form";
import renderSerial from "./renderSerial.vue";
import {
  machineOption,
  machineTypeOption,
  useMachineSelect,
} from "./options";

export default defineComponent({
  components: { renderSerial },
  setup() {
    const recordType = ref("randomSerial");
    const renderSerialRef = ref();
    const tableData = reactive([
    
    ]);
    const state = reactive({
      searchText: "",
      searchedColumn: "",
    });
    const formRef = ref("");
    const page = reactive({
      pageNum: 1,
      lineNum: 20,
      total: 0,
    });
    const formState = reactive({});

    const rules = reactive({});

    const { machieType, machineInfo, updateMachineType, updateMachineInfo } =
      useMachineSelect();

    const machineOptionByType = computed(() => {
      if (!machieType.value) return [];
      return machineOption[machieType.value];
    });

    const columns = [
      {
        title: "设备类型",
        align: "center",
        dataIndex: "type",
        key: "type",
        width: 90,
      },
      {
        title: "批次号",
        align: "center",
        dataIndex: "batch",
        key: "batch",
        width: 70,
      },
      {
        title: "设备机身号",
        align: "center",
        dataIndex: "serial",
        key: "serial",
        width: 120,
      },
      {
        title: "使用状态",
        align: "center",
        dataIndex: "isUsed",
        key: "isUsed",
        slots: { customRender: "isUsed" },
        width: 100,
      },
      {
        title: "生成时间",
        align: "center",
        dataIndex: "createDate",
        key: "createDate",
        width: 140,
      },
      {
        title: "操作",
        align: "center",
        dataIndex: "action",
        key: "action",
        width: 100,
        slots: { customRender: "action" },
      },
    ];
    const payload = reactive({
      serial: "",
      isUsed: null,
      generationTimes: "",
      batch: "",
      type: null,
      searchType: null,
    });
    const showSizeChange = (current, size) => {
      console.log(current, size);
      page.pageNum = current;
      page.lineNum = size;
      getData();
    };

    const getData = () => {
      selectedRowKeys.value.length = 0;
      getSerialList({
        type: payload.searchType,
        serial: payload.serial,
        isUsed: payload.isUsed,
        pageNum: page.pageNum,
        lineNum: page.lineNum,
      }).then((res) => {
        tableData.length = 0;
        page.total = res.data.total;
        res.data.records.forEach((item) => {
          if (item.type === "TE") {
            item.type = "天鹅";
          } else if (item.type === "TG") {
            item.type = "天鸽";
          }
        });
        tableData.push(...res.data.records);
      });
    };

    const onSearch = () => {
      page.pageNum = 1;
      getData();
    };

    const currenChange = (pageNumber) => {
      page.pageNum = pageNumber;
      getData();
    };

    const updateSerialStatus = (record) => {
      updateserial({
        id: record.id,
        isUsed: !record.isUsed,
      }).then((res) => {
        let toastType = res.code === 200 ? "success" : "warning";
        Toast(toastType, res.message, 3);
        console.log(renderSerialRef.value, "这是什么");
        renderSerialRef.value.checkGenerationTimes();
        getData();
      });
    };

    const updateStatus = (record) => {
      Modal.confirm({
        title: () => "提示",
        icon: () => createVNode(ExclamationCircleOutlined),
        content: () =>
          createVNode(
            "div",
            { style: "color:red;" },
            "是否变更设备序列号使用状态？"
          ),
        onOk() {
          updateSerialStatus(record);
        },
        onCancel() {
          console.log("Cancel");
        },
        class: "test",
      });
    };

    const renderSerialUpdate = (record) => {
      const targetItem = tableData.find(
        (item) => item.serial === record.serial
      );

      if (targetItem !== undefined) targetItem.isUsed = record.isUsed;
    };

    const updateSearchTable = () => {
      payload.isUsed = null;
      payload.serial = "";
      payload.searchType = null;
      onSearch();
    };

    const selectedRowKeys = ref([]);
    const onSelectChange = (key) => {
      selectedRowKeys.value.length = 0;
      selectedRowKeys.value.push(...key);
    };

    const deletePassword = ref(null);
    const deleteModalVisiable = ref(false);

    const openDeleteConfirmModal = () => {
      deleteModalVisiable.value = true;
    };

    const handelCancel = () => {
      deletePassword.value = null;
      deleteModalVisiable.value = false;
    };

    const handleDelete = () => {
      if (deletePassword.value === null || deletePassword.value === "") {
        return Toast("warning", "请输入删除密码", 3);
      } else if (deletePassword.value === "askscnb") {
        deleteserial(selectedRowKeys.value)
          .then((res) => {
            if (res.code === 200 && res.message === "成功") {
              Toast("success", "删除成功", 3);
            }
            selectedRowKeys.value.length = 0;
            getData();
            handelCancel();
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        Toast("warning", "密码错误", 3);
      }
    };

    const handleUpdateMachineType = (e) => {
      updateMachineType(e);
      if (!e) {
        payload.searchType = null;
        onSearch();
      }
    };

    const handleUpdateSearchType = (e, option) => {
      updateMachineInfo(e, option);
      onSearch();
    };

    getData();
    return {
      recordType,
      payload,
      columns,
      tableData,
      ...toRefs(state),
      currenChange,
      machieType,
      machineTypeOption,
      updateMachineType,
      updateMachineInfo,
      machineOptionByType,
      handleUpdateMachineType,
      handleUpdateSearchType,
      page,
      formRef,
      formState,
      rules,
      renderSerialRef,
      onSearch,
      showSizeChange,
      updateStatus,
      updateSearchTable,
      renderSerialUpdate,
      handleDelete,
      selectedRowKeys,
      onSelectChange,
      openDeleteConfirmModal,
      deletePassword,
      deleteModalVisiable,
      handelCancel,
    };
  },
});
</script>

<style lang="less" scoped>
.record-type {
  margin: 0 auto;
  display: block;
  width: 800px;
  text-align: center;
  margin-bottom: 0.20rem;
}

.table-striped td {
  background-color: #fafafa;
}

.df {
  display: flex;
}

.both-side {
  justify-content: space-between;
}

.df-around {
  justify-content: space-around;
}

.flex-end {
  justify-items: flex-end;
}

.vertical {
  align-items: center;
}

.log-box {
  width: calc(100vw - 200px);
  height: calc(100vh - 72px);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  overflow-x: scroll;
  .render-serial {
    width: 840px;
    background: #fff;
    border-radius: 0.10rem;
    padding: 20px;
    box-shadow: 0 0 0.10rem 0 #ccc;
    margin: 0 auto;
    height: calc(100vh - 120px);
    position: relative;
  }
}

// 表格
.log-table {
  width: 840px;
  background: #fff;
  border-radius: 0.10rem;
  padding: 20px;
  box-shadow: 0 0 0.10rem 0 #ccc;
  margin: 0 auto;
  height: calc(100vh - 120px);
  position: relative;

  .log-data {
    width: 100%;
    margin-bottom: 10px;
    // overflow: scroll;
    // overflow-x: hidden;
  }
}

.log-toolbar {
  margin-bottom: 0.20rem;
}

.log-pagination {
  position: absolute;
  bottom: 0.20rem;
  right: 0.20rem;
}

.mb10 {
  margin-bottom: 10px;
}

.ant-table-row-expand-icon {
  background: #1890ff;
  color: #fff;
}

.ant-table-row-expand-icon:focus,
.ant-table-row-expand-icon:hover {
  color: #fff;
}

.img-list {
  display: flex;
  justify-content: space-around;

  img {
    width: 533px;
    height: 400px;
  }
}

.switch-button {
  display: flex;
  align-items: center;

  img {
    width: 15px;
    height: 15px;
    margin-right: 5px;
  }
}
</style>